import { ProfileService } from '../profile.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ProfileAttachment } from '../profile-attachment.model';

@Component({
    selector: 'delete-profile-attachment',
    templateUrl: './delete-profile-attachment-dialog.component.html',
    styleUrls: [
        './delete-profile-attachment-dialog.component.css'
    ]
})
export class DeleteProfileAttachmentDialogComponent implements OnInit {

    // Properties
    attachment: ProfileAttachment;
    deleted: boolean;

    // Class Functions
    constructor (
        private dialogBox: MatDialogRef<DeleteProfileAttachmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private profileService: ProfileService
    ) { }

    // Event Functions
    ngOnInit() {
        // PRE: injected dialog data with an attachment
        // POST: initializes the data
        this.attachment = this.data.attachment;
    }

    delete() {
        // PRE: the delete button is clicked
        // POST: deletes the attachment and closes the dialog box
        this.profileService.deleteProfileAttachment(this.attachment.FileID).subscribe(() => {
            this.deleted = true;
            this.dialogBox.close();
        });
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
}
